import React, { useState } from "react";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
// css
import classes from "./PDFView.module.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const PDFView = ({ fileSrc,  scaleDoc = 1.2, customWrapperClass }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  // Replace S3 URL with CloudFront URL if available
  const replaceWithCloudfront = (url) => {
    if (!url) return url;
    const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
    if (cloudfrontUrl && url.includes("https://teckost.s3.amazonaws.com")) {
      return url.replace("https://teckost.s3.amazonaws.com", cloudfrontUrl);
    }
    return url;
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  let sourcename = fileSrc && fileSrc?.split("/");
  let fileName = sourcename[sourcename?.length - 1];

  // let sourceExtension = imgSrc && imgSrc.split(".");
  // let extension = sourceExtension[sourceExtension.length - 1];

  return (
    <div className={`${classes.pdfWrapper} ${customWrapperClass}`}>
      <p>{fileName}</p>
      <Document
        file={replaceWithCloudfront(fileSrc)}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={<p>Loading PDF...</p>}
      >
        <Page pageNumber={currentPage} className={classes.pdfPage} scale={viewportWidth < 768 ? 0.8 : scaleDoc} />
      </Document>

      <div className={classes.pdfBtn}>
        <p>
          {currentPage} - {numPages} Pages
        </p>
        <div className={classes.flex}>
          <Button className={classes.button} onClick={handlePrevPage}>
            <ArrowLeft
              sx={{
                fontSize: "2.4rem",
                color: "#000",
              }}
            />
          </Button>
          <Button className={classes.button} onClick={handleNextPage}>
            <ArrowRight
              sx={{
                fontSize: "2.4rem",
                color: "#000",
              }}
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PDFView;
